import { GET, POST } from "../../Methods";
import { APIS } from "../../APIS";

export const AdminLogin = async (data) => {
  // try {
  return await POST(APIS.Admin.AdminLoginAndDetails, data);
  // } catch (error) {
  //   console.error(error);
  //   return error;
  // }
};

export const AdminDetails = async () => {
  // try {
  return await GET(APIS.Admin.AdminLoginAndDetails);
  // } catch (error) {
  //   console.error(error);
  //   return error;
  // }
};


export const ChangePassword = async (data) => {
  // try {
  return await POST(APIS.ChangePassword, data);
  // } catch (error) {
  //   console.error(error);
  //   return error;
  // }
};